export interface IAddress {
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipCode: string;
    countyName: string;
}

export class Address implements IAddress {
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipCode: string;
    countyName: string;

    static createNewAddress = (address: Address): Address => {
        var newAddress = new Address();

        newAddress.addressLine1 = address.addressLine1;
        newAddress.addressLine2 = address.addressLine2;
        newAddress.city = address.city;
        newAddress.state = address.state;
        newAddress.zipCode = address.zipCode;
        newAddress.countyName = address.countyName;

        return newAddress;
    };
}

export class AddressInitialized implements IAddress {
    addressLine1 = "";
    addressLine2: string;
    city = "";
    state = "";
    zipCode = "";
    countyName = "";
}